import { Widget } from '@/modules/ta/legacy/widget/models/Widget';

export class MediaWidget extends Widget {
  constructor(model = {}) {
    super(model);

    this.cached_data = model.cached_data;
  }
}
